import { AtlasButtonProps, Button } from "@resource/atlas";
import { atlasCalendarCheck } from "@resource/atlas/icons";
import { useLogEvent } from "analytics";
import { LexicalEditor } from "lexical";

import { useInsertInterviews } from "./use-insert-interviews";

type InsertInterviewsButtonProps = {
  editor: LexicalEditor;
  logEvent?: ReturnType<typeof useLogEvent>;
  candidateTimezone?: string | null;
} & Omit<Partial<AtlasButtonProps>, "onClick" | "icon">;

export function InsertInterviewsButton({
  editor,
  logEvent,
  candidateTimezone,
  ...props
}: InsertInterviewsButtonProps) {
  const insertInterviews = useInsertInterviews({
    timezone: candidateTimezone ?? undefined,
    editor,
    logEvent: () => {
      logEvent?.("Share Interviews Quick Action Clicked");
    },
  });

  return (
    <Button {...props} icon={atlasCalendarCheck} onClick={insertInterviews}>
      Confirm interviews
    </Button>
  );
}
